<div class="nav">

<div class="nav-items">

  <a class="nav-item" [routerLink]="'/' + getCountry()" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{getString("home")}}</a>
  <a *ngIf="isBlackFriday()" class="nav-item" [routerLink]="'/' + getCountry() + '/' + getStoreUrl() + '/' + getMediaType() + '/' + getString('blackFridayDealsUrl')" [class.active]="isRouteActive(getString('blackFridayDealsUrl'))">
    <img src="./assets/images/black_friday.png">
  </a>
  <a class="nav-item" [routerLink]="'/' + getCountry() + '/' + getString('onSaleUrl')" [class.active]="isRouteActive(getString('onSaleUrl'))">{{getString("onsale")}}</a>
  <a class="nav-item" [routerLink]="getListsUrl()" [class.active]="isPersonalListsRouteActive()">{{getString("listNavigation")}}</a>
  <a class="nav-item" [routerLink]="getDiscoverUrl()" [class.active]="isPublicListsRouteActive()">{{getString("discover")}}</a>
  <a class="nav-item" [routerLink]="'/' + getCountry() + '/' + getString('cardDealsUrl')" routerLinkActive="active">{{getString("giftCardDeals")}}
    <span class="circle" *ngIf="hasNewCardDeal()"></span>
  </a>
  <a class="nav-item" href="https://www.cheapcharts.com/blog" routerLinkActive="active" target="_blank">Blog</a>
  <a class="nav-item" [routerLink]="'/' + getCountry() + '/' + getString('searchUrl')" routerLinkActive="active" rel="nofollow">{{getString("search")}}</a>
</div>

  <app-nav-search-bar class="nav-search-bar-component" (onSearchClicked)="searchClicked($event)"></app-nav-search-bar>

</div>
